// Internal job costing (GID-Session-009) — shared by the job's Costs panel and Settings.

export const COST_UNITS = [
  { value: 'ea', label: 'each' },
  { value: 'hr', label: 'hours' },
  { value: 'km', label: 'km' },
  { value: 'L', label: 'litres' },
  { value: 'kg', label: 'kg' },
  { value: 'day', label: 'days' }
];

/** What a category's type pre-fills on a new line. */
export const COST_KINDS = [
  { value: 'labour', label: 'Wages / labour', hint: 'Pre-fills the job\'s hours and the person\'s hourly cost' },
  { value: 'travel', label: 'Travel', hint: 'Pre-fills the per-km rate from Settings' },
  { value: 'fuel', label: 'Fuel', hint: 'Litres × price' },
  { value: 'material', label: 'Materials', hint: 'Cleaning agents, sealer, consumables' },
  { value: 'equipment', label: 'Equipment', hint: 'Depreciation or hire' },
  { value: 'other', label: 'Other', hint: '' }
];

export const unitLabel = (u) => COST_UNITS.find((x) => x.value === u)?.label || u || '';

/** Today in Brisbane as YYYY-MM-DD (no DST there). */
export const todayBrisbane = () => new Date().toLocaleDateString('en-CA', { timeZone: 'Australia/Brisbane' });

// Travel (GID-Session-014): fuel only — km × litres per 100 km × price per litre. Same maths as the server.
export const FUEL_DEFAULT_L_PER_100KM = 17;
const round1 = (n) => Math.round((Number(n) + Number.EPSILON) * 10) / 10;
const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;
export function fuelEstimate({ trips, km_one_way, l_per_100km, fuel_price, return_trip = true }) {
  const t = Math.max(0, Number(trips) || 0);
  const km_total = round1(t * (Number(km_one_way) || 0) * (return_trip ? 2 : 1));
  const litres = round2((km_total * (Number(l_per_100km) || 0)) / 100);
  const cost = round2(litres * (Number(fuel_price) || 0));
  return { trips: t, km_total, litres, cost };
}
